import { AccountContext } from "@/lib/storefront/account/account-service"

export function hasAnyRole(accountContext: AccountContext, roleIds: string[]) {
  const userRoles = accountContext?.roles?.userRoles
  if (!userRoles || userRoles.length === 0) return false
  if (!roleIds || roleIds.length === 0) return false

  const wanted = new Set(roleIds)
  return userRoles.some((ur: any) => ur?.roleID && wanted.has(ur.roleID))
}

export function hasAnyRoleId(userRoleIds: string[] | undefined, roleIds: string[]) {
  if (!userRoleIds || userRoleIds.length === 0) return false
  if (!roleIds || roleIds.length === 0) return false

  const wanted = new Set(roleIds)
  return userRoleIds.some((roleId) => wanted.has(roleId))
}
